import React from 'react'

const OpenModalButton = ({ modalButtonText }) => {
  const handleOnClick = () => {
    event.preventDefault()
    const loanModal = document.querySelector('.mtt-loan-modal')

    if (loanModal) {
      loanModal.classList.add('mtt-loan-modal--show')
    }
  }

  return (
    <a href='#' className='button outline' onClick={handleOnClick}>
      {modalButtonText}
    </a>
  )
}

export default OpenModalButton
